import { NgModule } from '@angular/core';
import { AssignmentModule } from '../assignment/assignment.module';
import { RlCommonModule } from '../rl-common/rl-common.module';
import { SectionComponent } from './section/section.component';
import { SectionsListComponent } from './sections-list/sections-list.component';

@NgModule({
    declarations: [SectionComponent, SectionsListComponent],
    imports: [
        RlCommonModule,
        AssignmentModule
    ],
    exports: [
        SectionsListComponent
    ]
})
export class SectionModule { }
